import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import {CreateDistributionList, DistributionList} from './types/types';

export class DistributionsService {
    // 📌 POST /distribution-list
    static async create(dto: CreateDistributionList): Promise<DistributionList> {
        const response: AxiosResponse<DistributionList> = await AxiosService.post(`/distribution-list`, dto);
        return response.data;
    }

    // 📌 POST /distribution-list
    static async update(id: string, dto: CreateDistributionList): Promise<DistributionList> {
        const response: AxiosResponse<DistributionList> = await AxiosService.put(`/distribution-list/${id}`, dto);
        return response.data;
    }

    // 📌 GET /distribution-list
    static async findAll(organization: string): Promise<DistributionList[]> {
        const response: AxiosResponse<DistributionList[]> = await AxiosService.get(`/distribution-list/organization/${organization}`);
        return response.data;
    }

    // 📌 GET /distribution-list/:id
    static async findOne(id: string): Promise<DistributionList> {
        const response: AxiosResponse<DistributionList> = await AxiosService.get(`/distribution-list/${id}`);
        return response.data;
    }

    // 📌 GET /distribution-list/:id
    static async remove(id: string): Promise<void> {
        await AxiosService.delete(`/distribution-list/${id}`);
    }
}